import { APP_VERSION } from './session';

const RELOADED_KEY = 'reloadedForVersion';

/**
 * Detects when the browser is running a stale cached bundle after a new
 * deployment: fetches version.json (never cached) and compares it to the
 * version baked into this bundle. On mismatch, clears the browser's caches
 * and service workers, then reloads so the fresh index.html and hashed
 * bundles are downloaded — no manual Ctrl+Shift+R needed.
 */
export async function reloadIfNewDeployment() {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;
    const { version } = await res.json();
    if (!version || version === APP_VERSION) return;

    // Guard against a reload loop if version.json is stale on a CDN/proxy
    if (sessionStorage.getItem(RELOADED_KEY) === version) return;
    sessionStorage.setItem(RELOADED_KEY, version);

    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
    if (navigator.serviceWorker) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((reg) => reg.unregister()));
    }
    window.location.reload();
  } catch {
    // Version check must never block the app (offline, dev server, etc.)
  }
}
